export default "__VITE_ASSET__CFY9m9SE__"